import React from 'react';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import type { ProfileDefault, ProfileExternal } from '../../../../types/uncinc_profile/profile';
import ProfileCard from '../Card';
import avatar from '../../../../assets/images/avatar.svg';

interface ProfileProps {
  entity: ImmutableEntity<ProfileDefault | ProfileExternal>;
}

const ProfileTeaser: React.FC<ProfileProps> = ({ entity }) => {
  const profile = entity.toJS();
  const type = profile.type[0].target_id;
  const isExternal = type === 'external_profile';
  const profileUrl =
    isExternal && 'field_link' in profile
      ? profile.field_link[0]?.uri
      // @ts-expect-error
      : `/${profile.path[0].langcode}${profile.path[0].alias}`;
  const profileFirstName = profile.field_first_name[0].value;
  const profileLastName = profile.field_last_name[0].value;

  // External Profiles from DAS were initially people, but can be organizations now too.
  // First- and Lastname are created with a split in the backend, and both fields are required.
  // So we want to prevent showing the orginizationname twice.
  const fullName = profileFirstName !== profileLastName
    ? [profileFirstName, profileLastName].join(' ') as unknown as string
    : profileFirstName;
  const profileFunctions = profile.field_functions[0]?.entity.name[0].value;
  const image = 'field_media_item' in profile && profile.field_media_item[0];

  return (
    <ProfileCard
      title={fullName}
      subtitle={profileFunctions}
      image={
        image
          ? (
            <DynamicMediaItem
              media={image}
              imageAspectRatio="1_1"
              mediaProps={{ role: 'presentation' }}
            />
          )
          : <img src={avatar} alt="" role="presentation" />

      }
      link={profileUrl}
      minimal
      isExternal={isExternal}
    />
  );
};

export default ProfileTeaser;

